<style scoped lang="less">
	@import '../../../assets/less/base.less';
	.new-home-footer {
		width: 100%;
		height: 320px;
		background: #262626;
		box-sizing: border-box;
		padding-top: 30px;
		.new-home-footer-con {
			width: 1200px;
			height: auto;
			margin: 0 auto;
			.new-home-footer-title {
				width: 100%;
				height: 30px;
				background: url(../../../assets/images/footerlogo.png) no-repeat 65px center;
				background-size: 121px 30px;
			}
			.foot-left {
				width: 344px;
				height: 140px;
				float: left;
				border-right: 1px dashed #aaaaaa;
				margin-top: 20px;
				margin-left: 70px;
				li {
					display: block;
					float: left;
					width: 100%;
					height: 14px;
					font-size: 14px;
					line-height: 14px;
					color: #ffffff;
				}
				li:first-child {
					margin-top: 10px;
				}
				li:nth-child(2),
				li:nth-child(4) {
					opacity: 0.5;
					margin-top: 15px;
				}
				li:nth-child(3) {
					margin-top: 25px;
				}
			}
			.foot-left-two {
				width: 512px;
				height: 140px;
				float: left;
				border-right: 1px dashed #aaaaaa;
				margin-top: 20px;
				li {
					display: block;
					float: left;
					width: 100%;
					height: 14px;
					font-size: 14px;
					line-height: 14px;
					color: #ffffff;
					text-indent: 65px;
				}
				li:first-child {
					margin-top: 10px;
				}
				li:nth-child(2),
				li:nth-child(3),
				li:nth-child(4) {
					opacity: 0.5;
					margin-top: 15px;
				}
			}
			.foot-left-three {
				width: 110px;
				height: 140px;
				float: left;
				margin-top: 20px;
				margin-left: 80px;
				li {
					display: block;
					float: left;
					width: 100%;
				}
				li:first-child {
					margin-top: 10px;
					height: 14px;
					font-size: 14px;
					line-height: 14px;
					color: #ffffff;
				}
				li:nth-child(2) {
					width: 110px;
					height: 110px;
					margin-top: 15px;
					img {
						width: 110px;
						height: 110px;
					}
				}
			}
			.foot-left-fours {
				width: 226px;
				height: 14px;
				float: left;
				display: block;
				margin-top: 45px;
				margin-left: 70px;
				a {
					width: 112px;
					height: 14px;
					font-size: 14px;
					color: #ffffff;
					opacity: 0.5;
					line-height: 14px;
					display: block;
					float: left;
				}
				a:hover {
					transition: all 0.2s;
					opacity: 1;
				}
				a:first-child {
					border-right: 1px solid #FFFFFF;
				}
				a:nth-child(2) {
					text-align: right;
				}
			}
			.foot-left-five {
				width: 700px;
				height: 12px;
				font-size: 12px;
				line-height: 12px;
				color: #ffffff;
				opacity: 0.5;
				text-align: right;
				float: right;
				margin-top: 45px;
				margin-right: 85px;
				a{
					color: #ffffff;
					&::hover{
						cursor: pointer;
					}
				}
			}
		}
	}

	.totop {
		width: 1300px;
		height: 50px;
		position: fixed;
		bottom: 86px;
		left: 50%;
		margin-left: -650px;
		a {
			width: 50px;
			height: 50px;
			display: block;
			float: right;
			background: rgba(0, 0, 0, 0.2);
			text-align: center;
			line-height: 50px;
			border-radius: 4px;
		}
		a:hover {
			transition: all 0.5s;
			background: rgba(0, 0, 0, 0.5);
		}
	}
</style>
<template>
	<div class="new-home-footer" id="new-home-footer">
		<div class="totop" v-if="local">
			<a href="#">
				<img src="../../../assets/images/totop.png" width="26" height="15" />
			</a>
		</div>
		<div class="new-home-footer-con">
			<p class="new-home-footer-title"></p>
			<ul class="foot-left">
				<li>流量主合作</li>
				<li>张女士：zhangliqiong@gm825.com</li>
				<li>广告主合作</li>
				<li>张女士：zhangliqiong@gm825.com</li>
			</ul>
			<ul class="foot-left-two">
				<li>办公地址</li>
				<li>玩咖欢聚文化传媒（北京）有限公司</li>
				<li>地址：北京市朝阳区安立路60号院润枫德尚苑6号楼4层</li>
				<li>电话：010-64820535</li>
			</ul>
			<ul class="foot-left-three">
				<li>关注公众号</li>
				<li>
					<img src="../../../assets/images/footem.jpg" />
				</li>
			</ul>
			<p class="foot-left-fours">
				<router-link to="/termsservice">媒体服务条款</router-link>
				<router-link to="/termsprivacy" style="padding-right:1em;">隐私权协议</router-link>
			</p>
			<p class="foot-left-five">©2019 Wanka Union 京网文（2016）2512-294号 <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备14038000号-1</a> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502035120" target="_blank">京公网安备11010502035120号</a></p>
		</div>

	</div>
</template>
<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				local: false
			};
		},
		methods: {
			btn_pos: function() {
				var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
				if(scrollTop > 84) {
					this.local = true
				} else if(scrollTop < 84) {
					this.local = false
				}
			}
		},
		created() {

		},
		mounted() {
			window.addEventListener('scroll', this.btn_pos)
		},
		destroyed() {
			window.removeEventListener('scroll', this.btn_pos)
		}
	};
</script>



// WEBPACK FOOTER //
// src/pages/NewHome/common/Newfooter.vue